import Qty from 'js-quantities';
export function convertUnit(array, fromUnit, toUnit) {
    fromUnit = normalize(fromUnit);
    toUnit = normalize(toUnit);
    if (fromUnit === toUnit)
        return array;
    const convert = Qty.swiftConverter(fromUnit, toUnit); // Configures converter
    //@ts-expect-error convert does not allowed typed array but it works
    return convert(array);
}
function normalize(unit) {
    unit = unit.replaceAll('°C', 'tempC');
    unit = unit.replaceAll('°F', 'tempF');
    unit = unit.replaceAll(/(^|\W)K(\W|$)/g, '$1tempK$2');
    return unit;
}
//# sourceMappingURL=convertUnit.js.map